import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const targetDeliveryGenband20Template: FormTemplate = {
  version: '1.0.0',
  name: 'Genband C20',
  key: 'GENBANDC20',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['name', 'afType', 'afId'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      name: {
        label: 'Template Name',
        type: 'text',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
            {
              type: 'length',
              length: 32,
              errorMessage: 'Exceeds maximum length, 32.  Please re-enter.',
            },
          ],
        },
      },
      afType: {
        label: 'AF IP Address',
        type: 'select',
        initial: 'GENBANDC20',
        options: [],
        validation: {
          required: true,
        },
      },
      afId: {
        label: 'Access Function Name',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select an Accesss Function',
            value: '',
          },
        ],
        validation: {
          required: true,
        },
      },
    },
  },
  targetInformation: {
    metadata: {
      min: 1,
      max: 1,
      layout: {
        rows: [
          [
            'GRPID',
            'LIID',
            'ACC',
          ],
          [
            'VARIANT',
            'CLLI',
            'FDCP',
          ],
          [
            'CGNDN',
            'CDNDN',
            '$empty',
          ],
          [
            'LTID',
            '$empty',
            '$empty',
          ],
          [
            'LEN',
            '$empty',
            '$empty',
          ],
          [
            'CDCTGTDN',
            'MONOMODE',
            'PNI',
          ],
        ],
      },
    },
    fields: {
      GRPID: {
        label: 'Group ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
        },
      },
      LIID: {
        label: 'LIID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
        },
      },
      ACC: {
        label: 'Target Access Type',
        type: 'select',
        initial: 'IBN',
        options: [
          {
            label: 'IBN',
            value: 'IBN',
          },
          {
            label: 'BRI',
            value: 'BRI',
          },
          {
            label: 'PRI',
            value: 'PRI',
          },
          {
            label: 'MFT',
            value: 'MFT',
          },
          {
            label: 'VA',
            value: 'VA',
          },
          {
            label: 'Hunt Member',
            value: 'HNT',
          },
          {
            label: 'Trunk',
            value: 'TRK',
          },
        ],
      },
      CDCTGTDN: {
        label: 'CDR Includes DN',
        type: 'checkbox',
        initial: true,
      },
      MONOMODE: {
        label: 'CC Delivered in MONO',
        type: 'checkbox',
        initial: true,
      },
      PNI: {
        label: 'Enable PNI',
        type: 'checkbox',
        initial: true,
      },
      VARIANT: {
        label: 'Protocol Variant',
        type: 'select',
        initial: 'ETSIPRI',
        hide: 'true',
        options: [
          {
            label: 'ETSIPRI',
            value: 'ETSIPRI',
          },
          {
            label: 'QSIGPRI',
            value: 'QSIGPRI',
          },
          {
            label: 'AUSTPRI',
            value: 'AUSTPRI',
          },
          {
            label: 'FDCP',
            value: 'FDCP',
          },
          {
            label: 'CDN_OUT_NATL',
            value: 'CDN_OUT_NATL',
          },
          {
            label: 'CDN_OUT_INTL',
            value: 'CDN_OUT_INTL',
          },
          {
            label: 'CDN_IN_NATL',
            value: 'CDN_IN_NATL',
          },
          {
            label: 'CLI_IN_INTL',
            value: 'CLI_IN_INTL',
          },
          {
            label: 'CLLI_IN_CLLI',
            value: 'CLLI_IN_CLLI',
          },
          {
            label: 'CLLI_OUT_CLLI',
            value: 'CLLI_OUT_CLLI',
          },
        ],
      },
      CLLI: {
        label: 'Common Lang. Location ID',
        type: 'text',
        initial: '',
        hide: 'true',
      },
      LTID: {
        label: 'Logical Terminal ID',
        type: 'text',
        hide: 'true',
        initial: '',
      },
      LEN: {
        label: 'Hunt Member Length',
        type: 'text',
        hide: 'true',
        initial: '',
      },
      FDCP: {
        label: 'FDCP',
        type: 'text',
        initial: '',
        hide: 'true',
      },
      CGNDN: {
        label: 'Calling DN',
        type: 'text',
        initial: '',
        hide: 'true',
        validation: {
          validators: [
            {
              type: 'length',
              length: 18,
              errorMessage: 'Exceeds maximum length, 18.  Please re-enter.',
            },
          ],
        },
      },
      CDNDN: {
        label: 'Called DN',
        type: 'text',
        initial: '',
        hide: 'true',
        validation: {
          validators: [
            {
              type: 'length',
              length: 18,
              errorMessage: 'Exceeds maximum length, 18.  Please re-enter.',
            },
          ],
        },
      },
    },
  },
  callContentChannels: {
    metadata: {
      min: 1,
      max: 1,
      layout: {
        rows: [
          [
            'IDN',
            'NAME',
            'SYS',
          ],
          [
            'BILLNO',
            'MAXINTERCEPT',
            'STATICCCC',
          ],
          [
            'CGSA',
            'BC',
            '$empty',
          ],
          [
            'REQ',
            'AUTH',
            'CUG',
          ],
          [
            'SANREQ',
            'SAN',
            '$empty',
          ],
        ],
      },
    },
    fields: {
      IDN: {
        label: 'Individual CCC DN',
        type: 'text',
        initial: '',
      },
      NAME: {
        label: 'CC Translation Name',
        type: 'text',
        initial: '',
      },
      SYS: {
        label: 'Translation System Name',
        type: 'text',
        initial: '',
      },
      BILLNO: {
        label: 'CCC Billing',
        type: 'text',
        initial: '',
      },
      MAXCCC: {
        label: 'Max CCC Pairs (4-255)',
        type: 'text',
        disabled: true,
        initial: '4',
        validation: {
          validators: [
            {
              type: 'length',
              length: 3,
            },
            {
              type: 'Interval',
              intervals: [[4, 255]],
              errorMessage: 'Must be between 1024 - 65535. Please re-enter.',
            },
          ],
        },
      },
      PREPENDRTEDIGS: {
        label: 'Enable Prepend Routing Digits',
        type: 'checkbox',
        initial: false,
      },
      NUMRTEDIGS: {
        label: 'Number Of Digits',
        type: 'select',
        initial: '0',
        disabled: true,
        options: [
          {
            label: '0',
            value: '0',
          },
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
          {
            label: '3',
            value: '3',
          },
          {
            label: '4',
            value: '4',
          },
          {
            label: '5',
            value: '5',
          },
          {
            label: '6',
            value: '6',
          },
          {
            label: '7',
            value: '7',
          },
        ],
      },
      MAXINTERCEPT: {
        label: 'Maximum Intercepts',
        type: 'text',
        initial: '',
      },
      STATICCCC: {
        label: 'Static CCCs',
        type: 'text',
        initial: '',
      },
      CGSA: {
        label: 'Calling Party Sub-Address',
        type: 'select',
        initial: 'REFNO',
        options: [
          {
            label: 'Target DN',
            value: 'TGTDN',
          },
          {
            label: 'Reference Number',
            value: 'REFNO',
          },
          {
            label: 'none',
            value: 'NONE',
          },
        ],
      },
      BC: {
        label: 'Bearer Capability',
        type: 'select',
        initial: 'SPEECH',
        options: [
          {
            label: 'Speech',
            value: 'SPEECH',
          },
          {
            label: '64K Data',
            value: '64K_DATA',
          },
        ],
      },
      REQ: {
        label: 'Require CCC Links',
        type: 'checkbox',
        initial: true,
      },
      AUTH: {
        label: 'Use Authentication',
        type: 'checkbox',
        initial: true,
      },
      CUG: {
        label: 'Enable Closed User Group',
        type: 'checkbox',
        initial: true,
      },
      SANREQ: {
        label: 'Enable Secondary Authentication Number',
        type: 'checkbox',
        initial: false,
      },
      SAN: {
        label: 'Secondary Auth Number ',
        type: 'text',
        initial: '',
        disabled: true,
      },
    },
  },
};

export const GENBAND_TARGET_CCC_ROWS = {
  targetInformation: {
    IBN: [
      ['GRPID', 'LIID', 'ACC'],
      ['CDCTGTDN', 'MONOMODE', 'PNI'],
    ],
    BRI: [
      ['GRPID', 'LIID', 'ACC'],
      ['LTID', '$empty', '$empty'],
      ['CDCTGTDN', 'MONOMODE', 'PNI'],
    ],
    PRI: [
      ['GRPID', 'LIID', 'ACC'],
      ['LTID', 'VARIANT', 'CLLI'],
      ['FDCP', 'CGNDN', 'CDNDN'],
      ['CDCTGTDN', 'MONOMODE', 'PNI'],
    ],
    TRK: [
      ['GRPID', 'LIID', 'ACC'],
      ['VARIANT', '$empty', '$empty'],
      ['CDCTGTDN', 'MONOMODE', 'PNI'],
    ],
    VA: [
      ['GRPID', 'LIID', 'ACC'],
      ['CDCTGTDN', 'MONOMODE', 'PNI'],
    ],
    HNT: [
      ['GRPID', 'LIID', 'ACC'],
      ['LEN', '$empty', '$empty'],
      ['CDCTGTDN', 'MONOMODE', 'PNI'],
    ],
    MFT: [
      ['GRPID', 'LIID', 'ACC'],
      ['CDCTGTDN', 'MONOMODE', 'PNI'],
    ],
  },
  callContentChannels: {
    IBN: [
      ['IDN', 'NAME', 'SYS'],
      ['BILLNO', 'MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC', '$empty'],
      ['REQ', 'AUTH', 'CUG'],
      ['SANREQ', 'SAN', '$empty'],
    ],
    BRI: [
      ['IDN', 'NAME', 'SYS'],
      ['BILLNO', 'MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC', '$empty'],
      ['REQ', 'AUTH', 'CUG'],
      ['SANREQ', 'SAN', '$empty'],
    ],
    PRI: [
      ['IDN', 'NAME', 'SYS'],
      ['BILLNO', 'PREPENDRTEDIGS', 'NUMRTEDIGS'],
      ['MAXINTERCEPT', 'STATICCCC', 'CGSA'],
      ['BC', '$empty', '$empty'],
      ['REQ', 'AUTH', 'CUG'],
      ['SANREQ', 'SAN', '$empty'],
    ],
    TRK: [
      ['IDN', 'NAME', 'SYS'],
      ['BILLNO', 'MAXCCC', 'PREPENDRTEDIGS'],
      ['NUMRTEDIGS', 'MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC', '$empty'],
      ['REQ', 'AUTH', 'CUG'],
      ['SANREQ', 'SAN', '$empty'],
    ],
    VA: [
      ['IDN', 'NAME', 'SYS'],
      ['BILLNO', 'MAXCCC', 'MAXINTERCEPT'],
      ['STATICCCC', 'CGSA', 'BC'],
      ['REQ', 'AUTH', 'CUG'],
      ['SANREQ', 'SAN', '$empty'],
    ],
    HNT: [
      ['IDN', 'NAME', 'SYS'],
      ['BILLNO', 'MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC', '$empty'],
      ['REQ', 'AUTH', 'CUG'],
      ['SANREQ', 'SAN', '$empty'],
    ],
    MFT: [
      ['IDN', 'NAME', 'SYS'],
      ['BILLNO', 'MAXINTERCEPT', 'STATICCCC'],
      ['CGSA', 'BC', '$empty'],
      ['REQ', 'AUTH', 'CUG'],
      ['SANREQ', 'SAN', '$empty'],
    ],
  },
};
